import {
  SourceEnum,
  StakingCurrEnum,
  StakingNetEnum
} from "pages/wallet/pages/staking/data"
import { missionsApi } from "store/apis/missionsAPI/missions.api"
import { TAGS, api } from "../../api"
import { IStaking, IStakingBonus, IStakingBonusSheet } from "./types"

const stakingAPI = api.enhanceEndpoints({
  addTagTypes: [TAGS.STAKING, TAGS.USER, TAGS.MISSIONS]
})

export const stakingEndpoints = stakingAPI.injectEndpoints({
  endpoints: (builder) => ({
    getStakingsList: builder.query<IStaking[], void>({
      query: () => ({ url: "/staking", method: "GET" }),
      providesTags: (quests) =>
        quests
          ? [
              ...quests.map(({ _id }: IStaking) => ({
                type: TAGS.STAKING as const,
                id: _id
              })),
              { type: TAGS.STAKING, id: "LIST" }
            ]
          : [{ type: TAGS.STAKING, id: "LIST" }],
      keepUnusedDataFor: 300
    }),
    createStaking: builder.mutation<
      any,
      {
        net?: StakingNetEnum
        token: StakingCurrEnum
        amount: number
        duration: number
        source: SourceEnum
      }
    >({
      query: (params: {
        amount: number
        duration: number
        source: SourceEnum
      }) => ({ url: "/staking", method: "POST", data: params }),
      invalidatesTags: () => [
        { type: TAGS.STAKING, id: "LIST" },
        { type: TAGS.USER, id: "user" }
      ],
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        await queryFulfilled

        dispatch(
          missionsApi.util.invalidateTags([
            { type: TAGS.MISSIONS, id: "MY_PROGRESS" },
            { type: TAGS.MISSIONS, id: "HAS_UNCLAIMED" }
          ])
        )
      }
    }),

    checkCompletedStakings: builder.mutation<any, void>({
      query: () => ({
        url: "/staking/check-completed",
        method: "GET"
      }),
      invalidatesTags: () => [{ type: TAGS.STAKING, id: "LIST" }]
    }),
    cancelStaking: builder.mutation<any, string>({
      query: (stakingId: string) => ({
        url: `/staking/${stakingId}`,
        method: "DELETE"
      }),
      invalidatesTags: () => [{ type: TAGS.STAKING, id: "LIST" }]
    }),
    confirmStaking: builder.mutation<any, string>({
      query: (stakingId: string) => ({
        url: `/staking/${stakingId}`,
        method: "PUT"
      }),
      invalidatesTags: () => [{ type: TAGS.STAKING, id: "LIST" }]
    }),
    stakingBonusSheet: builder.query<IStakingBonusSheet[], void>({
      query: () => ({
        url: `/staking/staking-bonus-sheet`,
        method: "GET"
      })
    }),
    myStakingBonus: builder.query<IStakingBonus, void>({
      query: () => ({
        url: `/staking/staking-bonus/my`,
        method: "GET"
      })
    }),
    stakingBonus: builder.query<IStakingBonus, string>({
      query: (id: string) => ({
        url: `/staking/staking-bonus/bonus/${id}`,
        method: "GET"
      })
    }),
    stakingBonusByUserId: builder.query<IStakingBonus, string>({
      query: (userId: string) => ({
        url: `/staking/staking-bonus/user-bonus/${userId}`,
        method: "GET"
      })
    }),
    checkReviewedStaking: builder.query<boolean, void>({
      query: () => ({
        url: `/staking/reviewed`,
        method: "GET"
      })
    })
  })
})
